import BaseModel from './base';

export const DELETION_PROCESS_STATUS = {
  pending: 1,
  processing: 2,
  done: 3,
  partial: 4,
};

export const DELETION_PROCESS_TYPE = { nomination: 1, group: 2 };

export default class EventDeletionProcess extends BaseModel {
  constructor(process = {}) {
    super(process, 'event-deletion-processes');
    this.status = process.status;
    this.status_name = process.status_name;
    this.event_id = process.event_id;
    this.event_group_id = process.event_group_id;
    this.event_nomination_id = process.event_nomination_id;
    this.to_event_nomination_id = process.to_event_nomination_id;
    this.transfers = process.transfers || [];
    this.subject_name = process.subject_name;
    this.can_retry = process.can_retry === true;
    this.error = process.error || null;
    this.events = process.events || {};
    this.failed_events = process.failed_events || [];
  }

  get isRunning() {
    return [DELETION_PROCESS_STATUS.pending, DELETION_PROCESS_STATUS.processing].includes(this.status);
  }

  get isDone() {
    return this.status === DELETION_PROCESS_STATUS.done;
  }

  get isPartial() {
    return this.status === DELETION_PROCESS_STATUS.partial;
  }
}
